import React, { Component } from 'react';
import './index.scss';

class LoadingPage extends Component {
  render() {
    return (
      <div className={(this.props.isOnboarding !== undefined) ? `loading-modal-additional loading-modal` : `loading-modal`}>
        <div className="zaps-spinner" />
        <p className="zaps-spinner-label">Loading…</p>
      </div>
    )
  }
}
export default LoadingPage;


// WEBPACK FOOTER //
// ./src/components/LoadingPage/index.jsx